

export const storageKeys = {
    TOKEN: 'apbui_token',
    EMAIL: 'apbui_email',
};



// WEBPACK FOOTER //
// ./src/js/util/storage.js